import React, { useEffect, useState } from "react";
import { API, get } from "../../../../config";
import { Card, CardContent } from "../../../../components/ui/card";
import { Button } from "../../../../components/ui/button";
import { ResponsiveDrawerForm } from "../../../../components/ResponsiveDrawerForm";
import Spin from "../../../../components/Spin";

const TrainingDetailsPopup = ({ trainingId, showView, setShowView, assessment = false}) => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const { data } = await get(
          `${API.ADMIN_TRAINING_DETAILS}/` + trainingId
        );
        setData(data.data);
        setLoading(false);
      } catch (e) {
        return null;
      }
    }
    fetchData();
  }, [trainingId, setData]);
  return (
    <ResponsiveDrawerForm
      description={""}
      title={assessment ? `Assessment Details` : `Training Details`}
      handleOpen={() => {}}
      handleClose={() => {}}
      className={"md:w-[65vw]"}
      open={showView}
      buttonClassName={""}
      setOpen={setShowView}
      read={true}
    >
      <>
        {loading ? (
          <Spin full expand={true} />
        ) : (
          <div className="space-y-6">
            {/* Training Image */}
            {!assessment && <div>
              <p className="text-sm font-semibold mb-2">Training Image:</p>

              <img
                src={data.banner_image}
                alt={data.title}
                className="h-52 rounded-lg border"
              />
            </div>}

            {/* Training Info */}
            <div className="space-y-1 text-sm">
              {!assessment && <p>
                <span className="font-semibold">Order:</span> {data.order}
              </p>}
              <p>
                <span className="font-semibold">Title:</span> {data.title}
              </p>
              <p>
                <span className="font-semibold">Description:</span>{" "}
                {data.description}
              </p>
              {!assessment && <p>
                <span className="font-semibold">Link:</span>{" "}
                <a
                  rel="noreferrer"
                  href={data.link}
                  target="_blank"
                  className="underline"
                >
                  {data.link}
                </a>
              </p>}
            </div>

            {/* Questions */}
            <Card>
              <CardContent className="p-0">
                <table className="w-full border-collapse text-sm">
                  <thead className="bg-muted">
                    <tr>
                      <th className="text-left px-4 py-3 border-b">Question</th>
                      <th className="text-center px-4 py-3 border-b w-[200px]">
                        Options / Answer
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {data.questions.map((q, index) => (
                      <tr key={q.id} className="border-b last:border-b-0">
                        <td
                          className={
                            q.type === "1" ? "px-4 py-3 align-top" : "px-4 py-3"
                          }
                        >
                          {index + 1}. {q.question}
                        </td>

                        <td className="px-4 py-3 text-center">
                          {/* TYPE 1 → MCQ */}
                          {q.type === "1" && (
                            <div className="flex flex-col items-center gap-2">
                              {q.options.map((opt) => (
                                <div
                                  key={opt.id}
                                  className="flex items-center gap-2"
                                >
                                  <Button
                                    size="sm"
                                    variant="outline"
                                    className={
                                      q.answer === opt.label
                                        ? "bg-[#d4f8d4] hover:bg-[#d4f8d4] dark:bg-[#476b47] dark:hover:bg-[#476b47] border-[#8cd98c]"
                                        : ""
                                    }
                                  >
                                    {opt.label} - {opt.text}
                                  </Button>
                                </div>
                              ))}
                            </div>
                          )}

                          {/* TYPE 2 → Yes / No (future-safe) */}
                          {q.type === "0" && (
                            <div className="flex justify-center gap-3">
                              <Button
                                size="sm"
                                variant="outline"
                                className={
                                  q.answer === "Yes"
                                    ? "bg-[#d4f8d4] hover:bg-[#d4f8d4] dark:bg-[#476b47] dark:hover:bg-[#476b47] border-[#8cd98c]"
                                    : ""
                                }
                              >
                                Yes
                              </Button>
                              <Button
                                size="sm"
                                variant="outline"
                                className={
                                  q.answer === "No"
                                    ? "bg-[#d4f8d4] hover:bg-[#d4f8d4] dark:bg-[#476b47] dark:hover:bg-[#476b47] border-[#8cd98c]"
                                    : ""
                                }
                              >
                                No
                              </Button>
                            </div>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </CardContent>
            </Card>
          </div>
        )}
      </>
    </ResponsiveDrawerForm>
  );
};

export default TrainingDetailsPopup;
